// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Login from "./components/Login.jsx";
import Dashboard from "./components/Dashboard.jsx"; 
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import BatchDetails from "./components/BatchDetails.jsx";
import CandidateDetails from "./components/CandidateDetails.jsx";
import AssessmentScore from "./components/AssessmentScore.jsx";

const App = () => {
  return (
    <GoogleOAuthProvider clientId="175418411943-0ku5v9onifji5i3179cbkb9dhc35dq9l.apps.googleusercontent.com">
      <Router>
        <Routes>
          {/* Public route (login) - only accessible when NOT authenticated */}
          <Route element={<ProtectedRoute reverse />}>
            <Route path="/" element={<Login />} />
          </Route>

          {/* Protected routes - require authentication */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/batch/:batchId" element={<BatchDetails />} />
            <Route path="/candidate-details/:batchId" element={<CandidateDetails />} />
            <Route path="/update-score/:batchCode" element={<AssessmentScore />} />


            {/* Catch-all route for protected paths */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;